import logo from "../../static/images/icon_512x512x96.png"; // or .png /.webp / .avif

type Props = {
    className?: string;
};

export default function BrandMark({ className }: Props): JSX.Element {
    return (
        <img
            src={logo}
            alt="GiveMeAVisual"
            className={className}
            width={64}
            height={64}
        />
    );
}
